import { TextInput } from '@cmg/common';
import React, { useState } from 'react';

type MultiValueStringInputControlProps = {
  value?: string | string[];
  onChange: (value: string[]) => void;
};

const MultiValueStringInputControl: React.FC<MultiValueStringInputControlProps> = ({
  onChange,
}) => {
  const [inputText, setInputText] = useState('');

  const handleInputChange = (newText: string | null) => {
    const currentInput = newText || '';
    setInputText(currentInput);

    if (!currentInput.trim()) {
      onChange([]);
      return;
    }

    const values = currentInput
      .split(',')
      .map(item => item.trim())
      .filter(Boolean);

    onChange(values);
  };

  return <TextInput value={inputText} onChange={handleInputChange} />;
};

export default MultiValueStringInputControl;
